export function throttleFunc(callback, delay) {
    let timerId;
    return function (...args) {
      if (!timerId) {
        timerId = setTimeout(() => {
          callback(...args);
          timerId = null;
        }, delay);
      }
    };
  };